import Vue from 'vue'
import {
  Button,
  Select,
  Form,
  FormItem,
  Input,
  Option,
  Checkbox,
  CheckboxGroup,
  Radio,
  RadioGroup,
  Upload,
  Dialog,
  Message,
  MessageBox,
  Divider,
  DatePicker,
  Cascader,
  Loading,
} from 'element-ui'
import VueQrcode from '@chenfengyuan/vue-qrcode'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

Vue.use(Button)
Vue.use(Select)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Option)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Upload)
Vue.use(Dialog)
Vue.use(Divider)
Vue.use(DatePicker)
Vue.use(Cascader)
Vue.use(Loading)

Vue.component(VueQrcode.name, VueQrcode)

Vue.prototype.$message = Message
Vue.prototype.$msgbox = MessageBox
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$prompt = MessageBox.prompt

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
